__turbopack_context__.v({
  "card": "ParagraphServices-module__0Cg0-G__card",
  "ctaBtn": "ParagraphServices-module__0Cg0-G__ctaBtn",
  "desc": "ParagraphServices-module__0Cg0-G__desc",
  "eyebrow": "ParagraphServices-module__0Cg0-G__eyebrow",
  "grid": "ParagraphServices-module__0Cg0-G__grid",
  "header": "ParagraphServices-module__0Cg0-G__header",
  "headerText": "ParagraphServices-module__0Cg0-G__headerText",
  "iconBox": "ParagraphServices-module__0Cg0-G__iconBox",
  "lead": "ParagraphServices-module__0Cg0-G__lead",
  "more": "ParagraphServices-module__0Cg0-G__more",
  "name": "ParagraphServices-module__0Cg0-G__name",
  "section": "ParagraphServices-module__0Cg0-G__section",
  "title": "ParagraphServices-module__0Cg0-G__title",
});
